import React from 'react';

const Shipping = () => {
    return (
        <>
            <div className="container">
                <br />
                <h3 className="text-center">SHIPPING POLICY</h3>
                <br /><br />
                <p className="mb16">
                    Mattress Compay Name ships its products to almost all parts of India. Orders placed will generally be shipped within 24 hrs. <b>All orders are delivered within 10 business days.</b> We ship on all days except Sunday and National Holidays. Shipping time may increase for third party shipments.
                </p>
                <p className="mb8">
                    <strong>Shipping Charges: </strong>
                </p>
                <p className="mb8">
                    The shipping charge applicable per quantity of the product can be checked by entering your pin code details on the product pages and the total shipping charge applicable on the order will be the sum of the charges for all chargeable product(s) in your order. The order level charge will be visible to you in the cart as well as when you enter the shipping address while you are checking out with your order.
                </p>
                <p className="mb8">
                    These shipping charges applicable are not refundable in the case of return/cancellation of the product or the order.
                    The shipping charges can be modified by Mattress Compay Name at any point without prior intimation. The new charges would reflect on the product page as well as in the checkout flow.
                </p>
                <p className="mb16">
                    Every once in a while, Mattress Compay Name brings out various offers in an attempt to satisfy customers. Various offers could be introduced for a limited span of time that enable free shipping of goods, subject to the fulfilment of the terms and conditions attached to the offer.
                </p>
                <p className="mb8">
                    <strong>Convenience Charges:</strong>
                </p>
                <p className="mb8">
                    Mattress Compay Name can levy convenience charges on specific orders based on the products, pin code, or the size of the shipment. This charge is not related to the shipping charges and can be applied to the order irrespective of the shipping cost.
                </p>
                <p className="mb8">
                    It is possible that an order can have: 1. only shipping charges applied (based on the order value), 2. only convenience charge applied, or 3. both shipping and convenience charges applied. Convenience charges, if applied, will be shown in the ‘Shipping Cost’ field in the cart/checkout sections. Users can see the details on the type of charge applied by clicking on the tooltip in the payment summary section.
                </p>
                <p className="mb16">
                    These convenience and shipping charges are not refundable in case of return/cancellation. Mattress Compay Name reserves the right to modify the logic for applying convenience charges at any time without prior notice.
                </p>
                <p className="mb8">
                    <strong>Estimated Delivery Time:</strong>
                </p>
                <p className="mb8">
                    During Covid lockdowns, delivery is subject to MHA and state government guidelines. There might be abnormal delays or cancellations due to the COVID-19 outbreak.
                </p>
                <p className="mb8">
                    For all areas serviced by reputed couriers, delivery will be within 3 to 4 business days after shipping (excluding Sundays and holidays). Heavier or bulky items may take longer. For other areas, we use Indian Postal Service, and delivery may take 1-2 weeks depending on location. The displayed delivery date is tentative.
                </p>
                <p className="mb8">
                    It may change after shipment. Once shipped, the Estimated Delivery Date will be shown in the ‘Order Details’ section under ‘My Account’.
                </p>
                <p className="mb16">
                    While Mattress Compay Name strives to meet delivery timelines, we are not liable for delays caused by unforeseen logistics issues. We reserve the right to cancel orders that are untraceable or delayed beyond acceptable timelines and will refund the corresponding amount.
                </p>
                <p className="mb8">
                    <strong>Address Change:</strong>
                </p>
                <p className="mb16">
                    You can change your delivery address only if the order is in Confirmed or Pending status and hasn't been shipped. If taxes or charges differ due to address change, we may not accept the request.
                </p>
                <p className="mb8">
                    <strong>Hidden Charges (Sales tax, Octroi etc): </strong>
                </p>
                <p className="mb16">
                    Our prices are all-inclusive. You don’t need to pay anything extra during checkout.
                </p>
                <p className="mb8">
                    <strong>International Locations:</strong>
                </p>
                <p className="mb16">
                    Currently, we do not deliver outside India.
                </p>
                <p className="mb8">
                    <strong>Tracking Packages: </strong>
                </p>
                <p className="mb16">
                    We will email the courier company name and tracking number to your registered email. If you don't receive it within 24 hours, check your spam folder. Tracking might be delayed by another 24 hours depending on the courier scan time.
                </p>
                <p className="mb8">
                    <strong>Non-availability on Delivery: </strong>
                </p>
                <p className="mb16">
                    Delivery partners will attempt 3 times before returning the package to our warehouse. Please include your mobile number in the address to ensure faster delivery.
                </p>
            </div>
        </>
    );
};

export default Shipping;
